import { function_ABM_CON_Monedas_Leer } from '../../ABM/CONT/ABM_CON_Monedas';
import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_GETBinario, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_COM_Cotizaciones_Cabecera_Listar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_COM_Cotizaciones_Cabecera_Listar"

    try {        
        const resulData = await llamadaAPI_GET("COM_Cotizaciones_Cabecera/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + 
            FechaDesde + "/" + 
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_COM_Cotizaciones_Cabecera_Leer = async (IdCotizacion) => {
    const NombreFuncion = "function_COM_Cotizaciones_Cabecera_Leer"

    try {        
        const resulData = await llamadaAPI_GET("COM_Cotizaciones_Cabecera/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + 
            IdCotizacion);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_COM_Cotizaciones_Cabecera_Insertar = async (Cotizacion) => {
    const NombreFuncion = "function_COM_Cotizaciones_Cabecera_Insertar";

    try {
        const cotizacionResult = await llamadaAPI_POST("COM_Cotizaciones_Cabecera/InsertarCompleto", Cotizacion);
        return cotizacionResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_COM_Cotizaciones_Cabecera_Modificar = async (Cotizacion) => {
    const NombreFuncion = "function_COM_Cotizaciones_Cabecera_Modificar";

    try {
        await llamadaAPI_PUT("COM_Cotizaciones_Cabecera/ModificarCompleto", Cotizacion);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_COM_Cotizaciones_Generar_JSON = async (IdPedido, 
    Fecha, IdProveedor, NumeroFantasia, NumeroPtoVta, Numero, CodigoMoneda, Cotizacion,
    ImporteBonificaciones, ImporteRecargos, ImporteFacturado, Concepto, Observaciones, 
    ConEnvio, FechaCompromiso, CodigoCondicionVenta, CodigoMonedaReferente, IdUsuarioCreador, 
    CodigoLocacion, ColeccionDetalles, ColeccionImpuestos) => {
    const NombreFuncion = "function_COM_Cotizaciones_Generar_JSON";

    try {
        const totalImporteNetoDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteNetoTotal, 0);
        const totalImporteBonificacionesDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteBonificacionesTotal, 0);
        const totalImporteRecargosDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteRecargosTotal, 0);
        const totalImporteSubTotalDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteSubTotalTotal, 0);
        const totalImporteIVADetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteIVATotal, 0);
        const totalImporteImpuestosInternosDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteImpuestosInternosTotal, 0);
        const totalImporteTotalDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteTotalTotal, 0);
        const totalImporteTotalPostImpuestos = totalImporteTotalDetalles;

        let CotizacionMonedaReferente = 1;
        let ImporteTotalPostImpuestosMonedaReferente = totalImporteTotalPostImpuestos;

        if (!ImporteFacturado) {
            ImporteFacturado = 0
        }

        if (!ImporteBonificaciones) {
            ImporteBonificaciones = 0
        }

        if (!ImporteRecargos) {
            ImporteRecargos = 0
        }

        if (!CodigoMonedaReferente) {
            CodigoMonedaReferente = CodigoMoneda
            CotizacionMonedaReferente = 1
        }
        else {
            const MonedaReferente = await function_ABM_CON_Monedas_Leer(CodigoMonedaReferente)
            CotizacionMonedaReferente = MonedaReferente.data[0].Cotizacion
            ImporteTotalPostImpuestosMonedaReferente = totalImporteTotalPostImpuestos / CotizacionMonedaReferente
        }

        const JSON = {
            IdPedido: IdPedido,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdTipoPedido: 2,
            Fecha: Fecha,
            IdProveedor: IdProveedor,
            NumeroFantasia: NumeroFantasia,
            NumeroPtoVta: NumeroPtoVta,
            Numero: Numero,  
            CodigoMoneda: CodigoMoneda,
            Cotizacion: Cotizacion,
            ImporteNeto: totalImporteNetoDetalles,
            ImporteBonificaciones: ImporteBonificaciones,
            ImporteRecargos: ImporteRecargos,
            ImporteBonificacionesItems: totalImporteBonificacionesDetalles,
            ImporteRecargosItems: totalImporteRecargosDetalles,
            ImporteTotal: totalImporteTotalDetalles,
            ImporteTotalPostImpuestos: totalImporteTotalPostImpuestos,
            ImporteFacturado: ImporteFacturado,
            Concepto: Concepto,
            Observaciones: Observaciones,
            IdEstado: 120,
            ConEnvio: ConEnvio, 
            FechaCompromiso: FechaCompromiso, 
            CodigoCondicionVenta: CodigoCondicionVenta, 
            CodigoMonedaReferente: CodigoMonedaReferente, 
            CotizacionMonedaReferente: CotizacionMonedaReferente, 
            ImporteTotalPostImpuestosMonedaReferente: ImporteTotalPostImpuestosMonedaReferente, 
            IdUsuarioCreador: IdUsuarioCreador, 
            CodigoLocacion: CodigoLocacion, 
            Terminal: localStorage.getItem("Terminal"), 
            Detalles: ColeccionDetalles.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
              })),
            Impuestos: ColeccionImpuestos.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
              }))
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_COM_Cotizaciones_Cabecera_Eliminar = async (IdPedido) => {
    const NombreFuncion = "function_COM_Cotizaciones_Cabecera_Eliminar"

    try {
        const resulData = await llamadaAPI_PUT("COM_Cotizaciones_Cabecera/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPedido);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_COM_Cotizaciones_Cabecera_ReporteCotizacion = async (IdCotizacion, formato) => {
    const NombreFuncion = "function_COM_Cotizaciones_Cabecera_ReporteCotizacion";

    try {
        const resulData = await llamadaAPI_GETBinario("COM_Cotizaciones_Cabecera/GenerarDocumento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCotizacion);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_COM_Cotizaciones_Cabecera_ReporteCotizacion_EnvioMail = async (IdCotizacion, toEmail) => {
    const NombreFuncion = "function_COM_Cotizaciones_Cabecera_ReporteCotizacion_EnvioMail";

    try {
        const resulData = await llamadaAPI_GET("COM_Cotizaciones_Cabecera/EnvioMail/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCotizacion + "/" +
            await TratamientoDeParametroParaURI(toEmail));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};